import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let navIsInit = false;

const navMobile = (lenis) => {
  const siteHeader = document.querySelector('.o-site-header');
  const mainNav = document.querySelector('#nav-main');
  const mainNavBtn = document.querySelector('#toggle-menu');
  if (!siteHeader || !mainNav || !mainNavBtn) return;

  gsap.set(mainNav, { autoAlpha: 0, y: -16 });

  const showHeader = () => {
    gsap.killTweensOf(siteHeader);
    gsap.set(siteHeader, { autoAlpha: 1, yPercent: 0, y: 0 });
  };

  const TMenu = gsap.timeline({
    paused: true,
    reversed: true,
    defaults: { overwrite: 'auto' },
    onStart: () => {
      siteHeader.classList.add('is-menu-open');
      showHeader();
      lenis?.stop?.();
    },
    onReverseComplete: () => {
      siteHeader.classList.remove('is-menu-open');
      lenis?.start?.();
    },
  });

  TMenu.fromTo(mainNav, { autoAlpha: 0, y: 16 }, { autoAlpha: 1, y: 0, duration: 0.6 });

  const onToggle = () => {
    const shouldOpen = TMenu.reversed();

    mainNavBtn.classList.toggle('close', shouldOpen);
    mainNavBtn.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');

    if (shouldOpen) {
      siteHeader.classList.add('is-menu-open');
      showHeader();
      TMenu.play();
      return;
    }

    TMenu.reverse(0);
  };

  mainNavBtn.addEventListener('click', onToggle, { passive: true });

  const subMenusButtons = mainNav.querySelectorAll('.m-main-nav__button');
  subMenusButtons.forEach((btn) => {
    const submenu = btn.parentElement?.nextElementSibling;
    if (!submenu) return;

    const TSubmenu = gsap.timeline({
      paused: true,
      reversed: true,
      defaults: { overwrite: 'auto' },
    });

    TSubmenu.from(submenu, { height: 0, duration: 0.5 })
      .to(submenu, { marginTop: 24, duration: 0.5 }, 0)
      .fromTo(btn, { rotate: 0 }, { rotate: 180, duration: 0.5 }, 0)
      .from(
        submenu.querySelectorAll('.m-main-nav__subItem'),
        {
          y: 32,
          autoAlpha: 0,
          duration: 0.3,
          stagger: { amount: 0.2 },
        },
        0.4
      );

    btn.addEventListener(
      'click',
      () => {
        TSubmenu.reversed() ? TSubmenu.play() : TSubmenu.timeScale(1.5).reverse(0);
      },
      { passive: true }
    );
  });
};

const animHeader = () => {
  const siteHeader = document.querySelector('.o-site-header');
  if (!siteHeader) return;

  let lastDirection = 0;

  ScrollTrigger.create({
    start: '200px top',
    end: 99999,
    onUpdate: (self) => {
      if (siteHeader.classList.contains('is-menu-open')) return;
      if (self.direction === lastDirection) return;
      lastDirection = self.direction;

      self.direction === -1
        ? gsap.to(siteHeader, { autoAlpha: 1, yPercent: 0, duration: 0.4, ease: 'power2.out', overwrite: true })
        : gsap.to(siteHeader, { autoAlpha: 0, yPercent: -100, duration: 0.4, ease: 'power2.in', overwrite: true });
    },
  });
};

export function initMainNav(lenis) {
  const mql = window.matchMedia('(max-width: 1439px)');

  const maybeInit = () => {
    if (!mql.matches || navIsInit) return;
    navIsInit = true;
    navMobile(lenis);
  };

  maybeInit();
  animHeader();

  mql.addEventListener('change', maybeInit);
}
